import {
  ButtonGroup,
  List,
  ListItem,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  Text,
  Link,
} from "@certn/cascadia-react";
import { weights } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

export function SupportingInfoModal() {
  const { t } = useTranslation();

  return (
    <ModalTrigger
      trigger={() => (
        <Link
          testID="learn-more"
          textStyle="global/body-secondary"
          textColor="text-weak"
        >
          <Trans>Learn more</Trans>.
        </Link>
      )}
    >
      {(close) => (
        <LegacyModal>
          <ModalHeader close={close} title={t("Supporting documents")} />
          <ModalContent>
            <Text style="global/body-primary">
              <Trans>
                Supporting documents may be used to validate the 4 required
                identification documents. These documents are required to
                provide evidence of a name change. Example documents include but
                are not limited to:
              </Trans>
            </Text>
            <br />
            <br />
            <List type="unordered">
              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Change of name certificate
                  </strong>{" "}
                  issued by the Australian Registry of Births, Deaths and
                  Marriages
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian marriage certificate
                  </strong>{" "}
                  issued by a state or territory (church or celebrant-issued
                  certificates are not accepted)
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Foreign marriage certificate
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Deed poll certificate
                  </strong>
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Relationship certificate
                  </strong>{" "}
                  issued by a state or territory Births, Deaths and Marriages
                </Trans>
              </ListItem>
            </List>
          </ModalContent>
          <ModalFooter>
            <ButtonGroup>
              <PrimaryButton onPress={close} size="medium">
                <Trans>Okay</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </ModalFooter>
        </LegacyModal>
      )}
    </ModalTrigger>
  );
}
